import { NavLink } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

const menuItems = [
  { to: '/', label: 'Genel Bakış', icon: 'ri-dashboard-line', end: true },
  { to: '/customers', label: 'Müşteriler', icon: 'ri-team-line' },
  { to: '/quotes', label: 'Teklifler', icon: 'ri-file-list-3-line' },
  { to: '/projects', label: 'İşler / Projeler', icon: 'ri-briefcase-line' },
  { to: '/tasks', label: 'Görevler', icon: 'ri-task-line' },
  { to: '/purchases', label: 'Satın Alma', icon: 'ri-shopping-cart-2-line' },
  { to: '/finance', label: 'Finans', icon: 'ri-bank-line' },
  { to: '/service', label: 'Servis / Revizyon', icon: 'ri-tools-line' },
  { to: '/calendar', label: 'Takvim', icon: 'ri-calendar-line' },
  { to: '/reports', label: 'Raporlar', icon: 'ri-bar-chart-2-line' },
  { to: '/files', label: 'Dosyalar', icon: 'ri-folder-2-line' },
];

interface SidebarProps {
  open: boolean;
  onClose: () => void;
}

export default function Sidebar({ open, onClose }: SidebarProps) {
  const { user, signOut } = useAuth();
  const email = user?.email ?? '';
  const displayName = email ? email.split('@')[0] : 'Yönetici';
  const initial = email ? email[0].toUpperCase() : '3D';
  return (
    <>
      {open && <div className="fixed inset-0 z-30 bg-foreground-950/50 lg:hidden" onClick={onClose} />}
      <aside
        className={`fixed inset-y-0 left-0 z-40 flex w-64 flex-col bg-foreground-950 transition-transform lg:translate-x-0 ${
          open ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="flex h-16 items-center gap-3 border-b border-foreground-900 px-5">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-bold text-white">
            3D
          </div>
          <div className="min-w-0">
            <p className="font-heading text-sm font-semibold leading-tight text-white">3D Machine</p>
            <p className="text-[11px] leading-tight text-foreground-400">İş Yönetim Paneli</p>
          </div>
        </div>

        <nav className="flex-1 overflow-y-auto px-3 py-4">
          <p className="px-3 pb-2 text-[11px] font-semibold uppercase tracking-wider text-foreground-500">Menü</p>
          <div className="space-y-1">
            {menuItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={onClose}
                className={({ isActive }) =>
                  `group flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary-500 text-white'
                      : 'text-foreground-300 hover:bg-foreground-900 hover:text-white'
                  }`
                }
              >
                <span className="flex h-5 w-5 items-center justify-center">
                  <i className={`${item.icon} text-base`} />
                </span>
                <span className="whitespace-nowrap">{item.label}</span>
              </NavLink>
            ))}
          </div>

          <div className="my-3 border-t border-foreground-900" />

          <NavLink
            to="/settings"
            onClick={onClose}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors ${
                isActive ? 'bg-primary-500 text-white' : 'text-foreground-300 hover:bg-foreground-900 hover:text-white'
              }`
            }
          >
            <span className="flex h-5 w-5 items-center justify-center">
              <i className="ri-settings-4-line text-base" />
            </span>
            <span className="whitespace-nowrap">Ayarlar</span>
          </NavLink>
        </nav>

        <div className="border-t border-foreground-900 p-3">
          <div className="flex items-center gap-3 rounded-lg bg-foreground-900 p-2">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-accent-500 text-sm font-bold text-white">
              {initial}
            </div>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-semibold text-white">{displayName}</p>
              <p className="truncate text-[11px] text-foreground-400">Yönetici</p>
            </div>
            <button
              type="button"
              onClick={() => signOut()}
              className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md text-foreground-400 transition-colors hover:bg-foreground-800 hover:text-white"
              title="Çıkış Yap"
            >
              <i className="ri-logout-box-r-line" />
            </button>
          </div>
        </div>
      </aside>
    </>
  );
}